export default {
  'advertisementPicturesManagement.image': 'Imgae',
  'advertisementPicturesManagement.link': 'Link',
  'advertisementPicturesManagement.banner': 'Banner',
  'advertisementPicturesManagement.uploadBtn': 'Click to Add a image',
  'advertisementPicturesManagement.uploadTips':
    'Image size is 1920*427px .jpg .jpeg .gif .png .bmp; Size is less than 2M;',
  'advertisementPicturesManagement.deleteTips':
    'Are you sure delete this task?',
    'advertisementPicturesManagement.uploadLimit': 'Image must smaller than 2MB!',
    'advertisementPicturesManagement.uploadFile': 'You can only upload jpg/jpeg/gif/png/bmp file!',
    'advertisementPicturesManagement.uploadCount': 'Upload the number of pictures between 1 to 5.',
    'advertisementPicturesManagement.success': 'file uploaded successfully.',
    'advertisementPicturesManagement.fail': 'file upload failed.',
    'advertisementPicturesManagement.uploadCarousel': 'Upload Carousel',
    'advertisementPicturesManagement.uploadCountTips': 'Up to 5 advertisement pictures can be configured'
};